import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/components/ThemeProvider";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import NetworkPage from "@/pages/Network";
import Layer1Page from "@/pages/Layer1Page";
import NodesPage from "@/pages/NodesPage";
import AIComputePage from "@/pages/AIComputePage";
import StoragePage from "@/pages/StoragePage";
import DevelopersPage from "@/pages/DevelopersPage";
import TokenPage from "@/pages/TokenPage";
import WhitepaperPage from "@/pages/WhitepaperPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";

function App() {
    return (
        <HelmetProvider>
            <ThemeProvider>
                <div className="App grain bg-page">
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/network" element={<NetworkPage />} />
                            <Route path="/layer-1" element={<Layer1Page />} />
                            <Route path="/nodes" element={<NodesPage />} />
                            <Route path="/ai-compute" element={<AIComputePage />} />
                            <Route path="/storage" element={<StoragePage />} />
                            <Route path="/developers" element={<DevelopersPage />} />
                            <Route path="/token" element={<TokenPage />} />
                            <Route path="/whitepaper" element={<WhitepaperPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/blog" element={<BlogList />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster position="bottom-right" theme="system" richColors />
                </div>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
